import Typography from '@mui/material/Typography'

const Label = ({
  children,
  ...props
}) =>
  <Typography
    variant="labelBig"
    color="neutral.main"
    {...props}
  >
    {children}
  </Typography>

export default Label